import { cn } from '@/lib/classNames';

export type ErrorMessageProps = {
	message?: string;
	className?: string;
};

export const ErrorMessage = ({ message, className }: ErrorMessageProps) => {
	if (!message) return null;

	return (
		<p
			className={cn(
				'inline-flex w-full items-center whitespace-nowrap text-xs text-dm-red',
				className
			)}
		>
			{message}
		</p>
	);
};
